import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface MatchingChannelPresentationConfig {

  /** 渠道模板；是匹配展示版本与主题的唯一选择依据。 */
  channelTemplate?: unknown

  /** 对客品牌字段；匹配页没有品牌节点，因此不参与本页的展示配置解析。 */
  showChannelName?: unknown
}

export interface MatchingPresentation {

  /** 由 channelTemplate 映射出的等待页主题。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveMatchingPresentation — 将渠道原始配置映射为匹配页可消费的 v2 主题。
 * 仅 channelTemplate 决定 v1/v2 与主题；本页没有品牌展示，showChannelName 不参与解析，
 * 非 2~6 的模板返回 null 以保持旧等待页，避免由流程状态或品牌字段猜测皮肤版本。
 * @param {unknown} detail 渠道详情接口返回的原始数据
 * @returns {MatchingPresentation | null} 有效的 v2 匹配展示配置，或继续使用旧展示的 null
 */
export const resolveMatchingPresentation = (detail: unknown): MatchingPresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as MatchingChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  return theme ? { theme } : null
}
